import * as most from 'most'
import request from 'superagent'
import {history} from 'most-history'
import {createLocation} from 'history'
import {
  combineEpics,
  // selectArray,
  select
} from 'redux-most'

import R from 'ramda'

// import {
//  setNavigation
// } from './actions'

import {
  isInstAdmin,
  toQueryString,
  isNilOrEmpty,
  notNilOrEmpty,
  isLicenseAdmin,
  isAuthAdmin,
  isLicenseViewer
} from './utils'

import {
  ENDINGS,
  METHODS,
  AUTH_API_URL,
  APP_TYPE,
  ACTIONS,
  PAGES
} from './constants'

const {
  push,
  stream
} = history()

const xhrDb = {
}

const makeRequest = (action) => {
  const {
    actionSet = ACTIONS.FETCH_LIST,
    method = 'get',
    url = `${AUTH_API_URL}/users`,
    _id = null,
    statePath = ['pages', PAGES.USERS],
    payload,
    query
  } = action

  // abort based on url
  if (xhrDb[url]) {
    xhrDb[url].abort()
  }

  const xhr = request[method](url)
    .withCredentials()
    .set('Content-Type', 'application/json')
    .accept('json')

  if (payload && (method === METHODS.POST || method === METHODS.PUT || method === METHODS.PATCH)) {
    xhr.send(payload)
  }

  if (query && (method === METHODS.GET)) {
    xhr.query(query)
  }

  // save so we can abort later
  xhrDb[url] = xhr

  const req$ = most.of({type: actionSet[ENDINGS.REQUEST], url, _id, statePath})

  const progress$ = most.fromEvent('progress', xhr)
    .map(e => {
      return {
        type: actionSet[ENDINGS.PROGRESS],
        statePath,
        e
      }
    })

  const done$ = most.fromPromise(xhr)
    .recoverWith((err) => {
      if (err.status === 401 || err.status === 403) {
        return most.of({
          _id,
          type: ACTIONS.NAVIGATION.GO_TO_LOGIN,
          error: R.path(['response', 'body', 'error'], err),
          locationPath: R.path(['locationPath'], action),
        })
      }

      if (err.status === 500 || err.status === undefined) {
        // Show available error only in webAdmin front-end alert
        if (err.response && err.response.body && err.response.body.error) {
          window.alert(`Error: ${err.response.body.error}`)
        } else {
          window.alert('Error: API unreachable')
        }
        return most.of({type: 'XHR_ERROR', error: 'Error: API unreachable', _id, statePath})
      }

      window.alert(`Error ${err.status}: ${R.path(['response', 'body', 'error'], err)}`)
      return most.of({type: 'XHR_ERROR', error: err, _id, statePath})
    })
    .map(res => {
      if (res.error && res.type) {
        return res
        // this is an error
      }
      // we pass all action fields back on error and
      // success (eg _id, onSuccessAction, query)
      // these are used in reducers and epics
      if (R.path(['body', 'error'], res)) {
        window.alert(R.path(['body', 'error'], res))
        return R.merge(action, {
          type: actionSet[ENDINGS.FAILURE],
          error: R.path(['body', 'error'], res),
          body: R.propOr({}, 'body', res)
        })
      }
      return R.merge(action, {
        type: actionSet[ENDINGS.SUCCESS],
        body: R.propOr({}, 'body', res)
      })
    })

  return most.mergeArray([req$, progress$, done$])
}

const map = R.curry(most.map)
const filter = R.curry(most.filter)
// const take = R.curry(most.take)
const tap = R.curry(most.tap)
const debounce = R.curry(most.debounce)
const join = R.curry(most.join)
const skip = R.curry(most.skip)

const minBy3 = R.compose(
  R.gt(R.__, 2),
  R.length,
  R.path(['query', 'term'])
)

const abortXhr = action => {
  if (action && action.url && xhrDb[action.url]) {
    // console.log('aborting', action.url)
    xhrDb[action.url].abort()
  }
}

const autocompleteEpic = action$ => R.compose(
  join,
  map(makeRequest),
  tap(abortXhr),
  debounce(500),
  filter(minBy3),
  select(
    ACTIONS.AUTOCOMPLETE.START
  )
)(action$)

const makeRequestEpic = R.compose(
  join,
  map(makeRequest),
  filter(a => !(/AUTOCOMPLETE_START$/.test(a.type))), // make sure NOT to include search START
  filter(a => a.type && /_START$/.test(a.type))
)

const onSuccessEpic = R.compose(
  map(({onSuccessAction}) => onSuccessAction),
  filter(action => action.onSuccessAction),
  skip(1)
)
const adminPages = R.values(PAGES)
const adminLocToPageName = R.compose(
  R.ifElse(
    R.contains(R.__, adminPages),
    R.identity,
    R.always(PAGES.USERS)
  ),
  R.defaultTo(PAGES.USERS),
  R.prop(0)
)
const fullApp = {
  urlToNav: url => {
    const loc = url.trim().split('/').filter(i => i.trim() !== '')
    const pageName = adminLocToPageName(loc)
    const pageNum = R.propOr(1, 1, loc)
    const perPage = R.propOr(20, 2, loc)
    const ids = R.drop(3, loc)
    // console.log('mapFirstLocationEventToFetchMe', location, pageName, ids)
    return {
      pageName,
      pageNum,
      perPage,
      ids
    }
  },
  navToLocationPush: navAction => {
    const {
      pageName = PAGES.USERS,
      pageNum = 1,
      perPage = 20,
      ids
    } = navAction
    const rest = R.omit(['type', 'pageName', 'pageNum', 'perPage', 'ids'], navAction)

    const url = `${AUTH_API_URL}/${pageName}`
    const pushUrl = (pageNum === 1 && perPage === 20 && isNilOrEmpty(ids))
      ? `/${pageName}`
      : (ids && ids.length)
        ? `/${pageName}/${pageNum}/${perPage}/${ids.join('/')}`
        : isNilOrEmpty(rest)
          ? `/${pageName}/${pageNum}/${perPage}`
          : `/${pageName}/${pageNum}/${perPage}${toQueryString(rest)}`

    const query = notNilOrEmpty(ids)
      ? {pageNum, perPage, ids}
      : R.merge({pageNum, perPage}, rest)

    push(createLocation(pushUrl, {pageName, url, query}))
  }
}

const thirdPartyLocToPageName = R.compose(
  R.ifElse(
    R.test(/^[0-9a-f]{24}$/),
    R.identity,
    R.always('')
  ),
  R.trim,
  R.defaultTo(''),
  R.prop(0)
)
const thirdPartyApp = {
  urlToNav: url => {
    const loc = url.trim().split('/').filter(i => i.trim() !== '')
    const pageName = thirdPartyLocToPageName(loc)
    return {pageName}
  },
  navToLocationPush: (navAction, state) => {
    const institutionId = R.path(['authStatus', 'user', 'institutions', 0, '_id'], state)
    const pageName = R.test(/^[0-9a-f]{24}$/, navAction.pageName) ? navAction.pageName : institutionId
    const url = `${AUTH_API_URL}/institutions/${pageName}`
    const pushUrl = '/' + (pageName)
    // console.log('navToLocationPush', url, pageName, navAction)
    push(createLocation(pushUrl, {pageName, url}))
  }
}

const shouldAdminUpdate = l => R.compose(
  R.complement(R.equals(R.pathOr({}, ['state', 'query'], l))),
  // R.tap(x => console.log('shouldAdminUpdate', x, l.state.query, R.equals(x, l.state.query))),
  R.path(['pages', l.state.pageName, 'navigation'])
)
// if we get a new history action, fetch the data if it is not the same as
// our current navigation/query  (e.g. pages[pageName].navigation)
const historyStreamToRequest = (action$, {getState}) => stream
  .skip(1) // allow fetchMe to take the first one
  // .tap(l => console.log('historyStreamToRequest', R.path(['state', 'query'], l), R.path(['pages', R.path(['state', 'pageName'], l), 'navigation'], getState())))
  .filter(l => R.cond([
    [R.propEq('type', APP_TYPE.FULL), shouldAdminUpdate(l)],
    [R.propEq('type', APP_TYPE.THIRD_PARTY), R.compose(isNilOrEmpty, R.path(['pages', l.state.pageName, 'usage']))], // no usage means fetch it
    [R.T, R.always(false)]
  ])(getState()))
  // .tap(l => console.log('===== fetching', l.state))
  .map(l => R.propEq('type', APP_TYPE.FULL, getState())
    ? {
      type: ACTIONS.FETCH_LIST.START,
      actionSet: ACTIONS.FETCH_LIST,
      statePath: ['pages', R.path(['state', 'pageName'], l)],
      url: R.path(['state', 'url'], l),
      query: R.path(['state', 'query'], l)
    }
    : {
      type: ACTIONS.FETCH_INSTITUTION.START,
      actionSet: ACTIONS.FETCH_INSTITUTION,
      statePath: ['pages', R.path(['state', 'pageName'], l)],
      url: R.path(['state', 'url'], l)
    }
  )

// for any time we change history, either we push a new url or we hit the back
// button, we want to update our global {pageName} state
// this _should_ be the only thing that calls SET_TAB
// nothing else act/reacts on this
const historyStreamToTabUpdate = (action$, store) => stream
  .skip(1) // allow fetchMe to take the first one
  .filter(loc => loc.state && loc.state.pageName)
  .map(loc => ({type: ACTIONS.NAVIGATION.SET_TAB, pageName: loc.state.pageName}))

const fetchMe = action$ => stream
  .delay(2) // we NEED a delay here due to some weird bug with take(1)
  .take(1) // only perform on first history event
  .map(location => ({
    type: ACTIONS.AUTH_STATUS.FETCH_ME.START,
    actionSet: ACTIONS.AUTH_STATUS.FETCH_ME,
    url: `${AUTH_API_URL}/me`,
    locationPath: location.pathname
  }))

const onFetchMeSuccesEpic = (action$, {getState}) => R.compose(
  // tap(action => console.log('onFetchMeSuccesEpic', action)),
  map(action => {
    const user = R.compose(R.defaultTo({}), R.path(['authStatus', 'user']))(getState())
    return isAuthAdmin(user) || isLicenseAdmin(user) || isLicenseViewer(user)
      ? R.merge({type: ACTIONS.NAVIGATION.GO_TO}, fullApp.urlToNav(action.locationPath))
      : isInstAdmin(user)
        ? R.merge({type: ACTIONS.NAVIGATION.GO_TO}, thirdPartyApp.urlToNav(action.locationPath))
        : {type: 'NO_ACTION'}
  }),
  select(ACTIONS.AUTH_STATUS.FETCH_ME.SUCCESS)
)(action$)

const navigateTo = (action$, {getState}) => R.compose(
  map(() => ({type: ACTIONS.NAVIGATION.GO_TO_SENT})),
  tap(action => {
    const state = getState()
    R.propEq('type', APP_TYPE.FULL, state)
      ? fullApp.navToLocationPush(action)
      : thirdPartyApp.navToLocationPush(action, state)
  }),
  filter(_ => R.either(R.propEq('type', APP_TYPE.FULL), R.propEq('type', APP_TYPE.THIRD_PARTY))(getState())),
  select(ACTIONS.NAVIGATION.GO_TO)
)(action$)

// we have a helper that sets the top-level pageName and pulls whatever
// navigation state that is set for it.  the history epic will then act on it
// we could also do this part in our app.  convenience puts it here in middleware.
// ({dispatch, getState})
const createLocationPush = ({getState}) => action => {
  return R.merge(
    {
      type: ACTIONS.NAVIGATION.GO_TO,
      pageName: action.pageName
    },
    R.path(['pages', action.pageName, 'navigation'], getState())
  )
}
const navigateToTab = (action$, store) => R.compose(
  map(createLocationPush(store)),
  select(ACTIONS.NAVIGATION.GO_TO_TAB)
)(action$)

const rootEpic = combineEpics([
  historyStreamToRequest,
  historyStreamToTabUpdate,
  fetchMe,
  onFetchMeSuccesEpic,
  autocompleteEpic,
  onSuccessEpic,
  makeRequestEpic,
  navigateTo,
  navigateToTab
])

export default rootEpic



// WEBPACK FOOTER //
// ./webAdmin/epics.js